import { handleActions } from "redux-actions";

import { setRoles } from "./actions";

const initialState = {
    isLoading: false,
    roles: {},
    ids: []
};

export const rolesReducer = handleActions(
    {
        [setRoles]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);